import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import {
  getAllEventOnGoingData,
  getAllEventRequestData,
  getAllPastEventData,
  getEventdelete,
} from "../../api";
import { useSelector } from "react-redux";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
import TableComponent from "../common/TableComponent";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Button, Modal } from "react-bootstrap";

import moment from "moment";

const EventManagement = () => {
  const { token } = useSelector((state) => state.profileReducer);
  // const [allEventData, setAllEventData] = useState([]);
  const [allEventRequest, setAllEventRequest] = useState([]);
  const [allEventOnGoingData, setallEventOnGoingData] = useState([]);
  const [allPassEventData, setAllPassEventData] = useState([]);
  const [allEventFilterData, setAllEventFilterData] = useState([]);
  const [allPassFilterData, setAllPassFilterData] = useState([]);
  const [allOngoingFilterData, setAllOngoingFilterData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const toast = useRef(null);
  const tableColumnTitles = [
    {
      name: "Sr.no",
      // field: "Sr.no",
      isSortFilter: false,
      isAction: false,
    },
    {
      name: "Event Name",
      field: "Event Name",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Date",
      // field: "Date",
      isSortFilter: false,
      isAction: false,
    },
    {
      name: "Time",
      // field: "Time",
      isSortFilter: false,
      isAction: false,
    },
    {
      name: "Location",
      field: "Location",
      isSortFilter: true,
      isAction: false,
    },
    {
      name: "Status",
      // field: "Status",
      isSortFilter: false,
      isAction: false,
    },
    { name: "Action", isSortFilter: false, isAction: true },
  ];

  // Pagination

  // Event Requested
  const getEventDataFromAPI = async () => {
    setIsLoading(true);
    getAllEventRequestData(token)
      .then((res) => {
        setIsLoading(false);
        setAllEventRequest(res?.data?.result?.data);
        setAllEventFilterData(res?.data?.result?.data);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  // on-going Event Requested

  const getOnGoingEventDataFromAPI = async () => {
    setIsLoading(true);
    getAllEventOnGoingData(token)
      .then((res) => {
        setIsLoading(false);
        setallEventOnGoingData(res?.data?.result?.data);
        setAllOngoingFilterData(res?.data?.result?.data);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const getPassEventDataFromAPI = async () => {
    setIsLoading(true);
    getAllPastEventData(token)
      .then((res) => {
        setIsLoading(false);
        setAllPassEventData(res?.data?.result?.data);
        setAllPassFilterData(res?.data?.result?.data);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  // Filtering
  const updateResponseData = (searchData, eventKey) => {
    if (eventKey === "event request") {
      searchData.map((ele) => {
        if (ele.searchField !== "") {
          if (ele?.searchValue !== "") {
            switch (ele.searchField) {
              // case "Sr.no":
              //   const dataSrno = allFilterData.filter((item) =>
              //     item?.index?.includes(ele.searchValue)
              //   );
              //   setAllEventRequest(dataSrno);
              //   break;
              case "Event Name":
                const dataEventName = allEventFilterData.filter((item) =>
                  item?.name
                    ?.toLowerCase()
                    ?.includes(ele.searchValue?.toLowerCase())
                );
                setAllEventRequest(dataEventName);
                break;
              // case "Date":
              //   const dataDate = allEventFilterData.filter((item) =>
              //   item?.name.index?.includes(ele.searchValue)
              // );
              // setAllEventRequest(dataDate);
              // break;
              // case "Time":
              // const dataDate = allEventFilterData.filter((item) =>
              //   item?.name.index?.includes(ele.searchValue)
              // );
              // setAllEventRequest(dataDate);
              // break;
              case "Location":
                const dataLocation = allEventFilterData.filter((item) =>
                  item?.location
                    ?.toLowerCase()
                    ?.includes(ele.searchValue?.toLowerCase())
                );
                setAllEventRequest(dataLocation);
                break;
              case "Status":
                const dataStatus = allEventFilterData.filter((item) =>
                  item?.status
                    ?.toLowerCase()
                    ?.includes(ele.searchValue?.toLowerCase())
                );
                setAllEventRequest(dataStatus);
                break;
              default:
                break;
            }
          } else {
            setAllEventRequest(allEventFilterData);
          }
        }
        return "";
      });
    } else if (eventKey === "ongoingevents") {
      searchData.map((ele) => {
        if (ele.searchField !== "") {
          if (ele?.searchValue !== "") {
            switch (ele.searchField) {
              // case "Sr.no":
              //   const dataSrno = allFilterData.filter((item) =>
              //     item?.index?.includes(ele.searchValue)
              //   );
              //   setallEventOnGoingData(dataSrno);
              //   break;
              case "Event Name":
                const dataEventName = allOngoingFilterData.filter((item) =>
                  item?.name?.includes(ele.searchValue)
                );
                setallEventOnGoingData(dataEventName);
                break;
              // case "Date":
              //   const dataDate = allOngoingFilterData.filter((item) =>
              //   item?.name.index?.includes(ele.searchValue)
              // );
              // setallEventOnGoingData(dataDate);
              // break;
              // case "Time":
              // const dataDate = allOngoingFilterData.filter((item) =>
              //   item?.name.index?.includes(ele.searchValue)
              // );
              // setallEventOnGoingData(dataDate);
              // break;
              case "Location":
                const dataLocation = allOngoingFilterData.filter((item) =>
                  item?.location?.includes(ele.searchValue)
                );
                setallEventOnGoingData(dataLocation);
                break;
              case "Status":
                const dataStatus = allOngoingFilterData.filter((item) =>
                  item?.status?.includes(ele.searchValue)
                );
                setallEventOnGoingData(dataStatus);
                break;
              default:
                break;
            }
          } else {
            setallEventOnGoingData(allOngoingFilterData);
          }
        }
        return "";
      });
    } else {
      searchData.map((ele) => {
        if (ele.searchField !== "") {
          if (ele?.searchValue !== "") {
            switch (ele.searchField) {
              // case "Sr.no":
              //   const dataSrno = allFilterData.filter((item) =>
              //     item?.index?.includes(ele.searchValue)
              //   );
              //   setAllPassEventData(dataSrno);
              //   break;
              case "Event Name":
                const dataEventName = allPassFilterData.filter((item) =>
                  item?.name?.includes(ele.searchValue)
                );
                setAllPassEventData(dataEventName);
                break;
              // case "Date":
              //   const dataDate = allFilterData.filter((item) =>
              //   item?.name.index?.includes(ele.searchValue)
              // );
              // setAllEventRequest(dataDate);
              // break;
              // case "Time":
              // const dataDate = allFilterData.filter((item) =>
              //   item?.name.index?.includes(ele.searchValue)
              // );
              // setAllEventRequest(dataDate);
              // break;
              case "Location":
                const dataLocation = allPassFilterData.filter((item) =>
                  item?.location?.includes(ele.searchValue)
                );
                setAllPassEventData(dataLocation);
                break;
              case "Status":
                const dataStatus = allPassFilterData.filter((item) =>
                  item?.status?.includes(ele.searchValue)
                );
                setAllPassEventData(dataStatus);
                break;
              default:
                break;
            }
          } else {
            setAllPassEventData(allPassFilterData);
          }
        }
        return "";
      });
    }
  };

  const deleteEvents = (id) => {
    setIsLoading(true);
    setShow(false);
    getEventdelete(id, token)
      .then((res) => {
        setIsLoading(false);
        toast.current.show({
          severity: "success",
          summary: `${res?.data?.message}`,
        });
        setTimeout(async () => {
          getEventDataFromAPI();
          getOnGoingEventDataFromAPI();
          getPassEventDataFromAPI();
        }, 2000);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "err",
          summary: `${err?.data?.message}`,
        });
      });
  };

  useEffect(() => {
    async function getAllAPI() {
      await getEventDataFromAPI();
      await getOnGoingEventDataFromAPI();
      await getPassEventDataFromAPI();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const adminTableRequests = (ele, index) => {
    return (
      <>
        <tr key={index} className="table-light">
          <td>{index + 1}</td>
          <td>{ele?.name ? ele?.name : "-"}</td>
          <td>{ele?.date ? moment(ele?.date).format("DD-MM-YYYY") : "-"}</td>
          <td>{ele?.time ? ele?.time : "-"}</td>
          <td>{ele?.location ? ele?.location : "-"}</td>
          <td>{ele?.status ? ele?.status : "-"}</td>
          <td>
            <Link
              // to="EventDetails"
              to={{
                pathname: "/event-management/EventDetails",
                search: `?eventId=${ele.id}`,
              }}
              aria-expanded="false"
              data-toggle="collapse"
              className="action-link "
            >
              <svg
                width="20"
                height="14"
                viewBox="0 0 20 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="me-2"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.3377 6.7875C17.8352 2.90106 14.164 0.28158 10.0002 0.125C5.83641 0.28158 2.1652 2.90106 0.662722 6.7875C0.613077 6.92482 0.613077 7.07518 0.662722 7.2125C2.1652 11.0989 5.83641 13.7184 10.0002 13.875C14.164 13.7184 17.8352 11.0989 19.3377 7.2125C19.3874 7.07518 19.3874 6.92482 19.3377 6.7875ZM6.25 7C6.25 4.92893 7.92893 3.25 10 3.25C12.0711 3.25 13.75 4.92893 13.75 7C13.75 9.07107 12.0711 10.75 10 10.75C7.92893 10.75 6.25 9.07107 6.25 7ZM7.5 7C7.5 8.38071 8.61929 9.5 10 9.5C10.663 9.5 11.2989 9.23661 11.7678 8.76777C12.2366 8.29893 12.5 7.66304 12.5 7C12.5 5.61929 11.3807 4.5 10 4.5C8.61929 4.5 7.5 5.61929 7.5 7ZM1.91897 7C3.18772 10.1687 6.68772 12.625 10.0002 12.625C13.3127 12.625 16.8127 10.1687 18.0815 7C16.8127 3.83125 13.3127 1.375 10.0002 1.375C6.68772 1.375 3.18772 3.83125 1.91897 7Z"
                  fill="black"
                />
              </svg>
            </Link>
            <Link
              aria-expanded="false"
              data-toggle="collapse"
              className="action-link "
              // onClick={() => deleteUser(ele.id)}
              onClick={() => {
                setDeleteId(ele.id);
                setShow(true);
              }}
            >
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.5 0.25H5.5V1.5H10.5V0.25ZM0.5 2.75V4H1.75V16.5C1.75 17.1904 2.30964 17.75 3 17.75H13C13.6904 17.75 14.25 17.1904 14.25 16.5V4H15.5V2.75H0.5ZM3 16.5V4H13V16.5H3ZM5.5 6.5H6.75V14H5.5V6.5ZM10.5 6.5H9.25V14H10.5V6.5Z"
                  fill="#212121"
                />
              </svg>
            </Link>
          </td>
        </tr>
      </>
    );
  };

  return (
    <>
      <Toast ref={toast} />

      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      {show && (
        <Modal
          show={show}
          onHide={() => setShow(false)}
          className="logout-modal"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="modal-title text-center">
            Are you sure you want to delete this Event?
          </Modal.Body>
          <Modal.Footer className="border-0 justify-content-center">
            <Button
              variant="secondary"
              className="me-3 yes-btn-cls-add"
              onClick={() => {
                deleteEvents(deleteId);
                getEventDataFromAPI();
                getOnGoingEventDataFromAPI();
                getPassEventDataFromAPI();
              }}
            >
              Yes
            </Button>
            <Button
              variant="secondary"
              className="no-btn-cls-add"
              onClick={() => {
                setDeleteId(null);
                setShow(false);
              }}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <div className="content-section">
        <div className="card main-user-card">
          <div className="row m-0">
            <div className="col-lg-12 mt-4 p-0 mr-2 d-flex justify-content-between align-items-center">
              <div className="title-heading">Event Management</div>
              <div className="right_section_action">
                <Link to="/event-management/AddEvent">
                  <button className="btn fill_btn float-right apply-btn-cls">
                    Add Event
                  </button>
                </Link>
              </div>
            </div>
          </div>

          {/* tabbing view start */}

          <div className="tabbing-view-all mt-4">
            <Tabs
              defaultActiveKey="event request"
              transition={false}
              id="noanim-tab-example"
              className=""
            >
              <Tab eventKey="event request" title="Event Request">
                <TableComponent
                  tableColumnTitles={tableColumnTitles}
                  tabRequests={allEventRequest}
                  tableRowRequests={adminTableRequests}
                  updateResponseData={(searchData) =>
                    updateResponseData(searchData, "event request")
                  }
                />
              </Tab>

              <Tab eventKey="ongoingevents" title="On-going Events">
                <TableComponent
                  tableColumnTitles={tableColumnTitles}
                  tabRequests={allEventOnGoingData}
                  tableRowRequests={adminTableRequests}
                  updateResponseData={(searchData) =>
                    updateResponseData(searchData, "ongoingevents")
                  }
                />
              </Tab>
              <Tab eventKey="pastevent" title="Past Event">
                <TableComponent
                  tableColumnTitles={tableColumnTitles}
                  tabRequests={allPassEventData}
                  tableRowRequests={adminTableRequests}
                  updateResponseData={(searchData) =>
                    updateResponseData(searchData, "pastevent")
                  }
                />
              </Tab>
            </Tabs>
          </div>

          {/* tabbing view over */}
        </div>
      </div>
    </>
  );
};
export default EventManagement;
